var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeanut02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1254.1 1360.5c29.8 227.5-145.6 329.8-214.7 342.5l-.4-1.9s-1.1-65.8-18.3-228.5c68.3-12.6 146.3-45.9 233.4-112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1039 1701l.4 1.9c-5 .9-9.4 1.4-13.2 1.4 0 0-19.5 4-55.2-7.1v-.2s-59.8-103.2-103.9-230.9c43.9 12.5 95.2 17.1 153.6 6.4 17.2 162.7 18.3 228.5 18.3 228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1205.8 1156.3c17.1 47.5 36 110.9 48.2 204.2-87 66.2-165.1 99.6-233.4 112-6.2-58.7-14.5-130.1-25.7-215.5-.9-7-1.8-14-2.5-20.8 63.8-7.9 134.8-31.1 210.5-79.2l2.9-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M995 1257c11.1 85.4 19.5 156.8 25.7 215.5-58.4 10.7-109.8 6.1-153.6-6.4-27-78.1-48-165.4-46-243.9 47.8 14 105.8 22.1 171.4 14 .7 6.8 1.6 13.8 2.5 20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M991.8 1027.4c-6.7 60.6-8.1 129.1.7 208.8-65.6 8.1-123.6 0-171.4-14 .7-25.5 3.8-50.1 9.9-73.2 13.3-49.8 27-95.4 39.6-138 35.5 8.2 76.6 14.7 121.2 16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1031.5 834.8c-15.3 56.2-31.6 118.5-39.8 192.6-44.6-1.7-85.7-8.2-121.2-16.3 18.5-62.7 34.3-118.8 42.2-172.6 37.5-2.9 78.3-4.6 118.8-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M991.8 1027.4c8.2-74.1 24.5-136.3 39.8-192.6 20.6-75.4 39.5-140 35.5-207.8-.6-9.7-1.4-19.7-2.5-29.8 54 3 113.7 15.5 178.5 41.8l1-.1c12.5 148.3-49.2 295.8-69.9 353.7-18.5 51.9 4.2 86.9 31.7 163.7l-2.8.7c-75.7 48.1-146.7 71.3-210.5 79.2-9-79.7-7.6-148.2-.8-208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1067 627c4 67.8-14.9 132.4-35.5 207.8-40.5-.9-81.3.8-118.8 3.6 9.4-63.6 7.7-123.8-13.8-187.4-3.2-9.3-6.3-19.2-9.3-29.5 49-17.1 107.6-28 174.8-24.2 1.2 10 2 20 2.6 29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1244 638.9l-1 .1c-64.9-26.2-124.5-38.7-178.5-41.8-7.2-67-25.3-141.2-48.3-206.3 40.2 4.3 84.7 13.1 133.8 27.7 7.2 9 14.6 18.4 22.2 28.2 45.7 58.9 66.2 125.6 71.8 192.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1016.1 390.9c23 65.1 41.1 139.3 48.3 206.3-67.2-3.8-125.7 7.1-174.8 24.2-19.1-65-35.2-146.9-41.5-220.1 45.4-12.2 100.8-17.6 168-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M902.2 215c55 0 115.4 37.8 247.6 203.7-49.1-14.6-93.5-23.4-133.8-27.7-33.3-94.7-77.3-170-113.8-176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M902.2 215c36.4 6 80.4 81.3 113.9 175.9-67.3-7.2-122.7-1.8-168 10.4-7.9-90.7-.9-168.2 33.5-184 7.8-1.5 14.8-2.3 20.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.2 401.3c6.4 73.3 22.4 155.2 41.5 220.1 3 10.3 6.1 20.2 9.3 29.5 21.5 63.6 23.2 123.8 13.8 187.4-7.9 53.8-23.8 109.9-42.2 172.6-12.5 42.6-26.3 88.1-39.6 138-6.2 23.1-9.2 47.6-9.9 73.2-2.1 78.5 19 165.8 46 243.9 44.1 127.8 103.9 231 103.9 231v.2c-44.5-13.9-114.1-51.2-202.6-148.8-155.9-171.9-104-467.8-38-583.7 66-116-86-267.9-66-471.8 18-183.2 148.9-261.5 217.3-275.5-34.5 15.7-41.4 93.2-33.5 183.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M881.7 217.4c-68.4 14-199.3 92.4-217.3 275.5-20 203.9 131.9 355.8 66 471.8-66 115.9-117.9 411.8 38 583.7 88.5 97.6 158.2 134.9 202.6 148.8 35.8 11.2 55.2 7.1 55.2 7.1 3.8 0 8.2-.5 13.2-1.4 69.1-12.7 244.6-115 214.7-342.5-12.2-93.2-31.2-156.7-48.2-204.2-27.6-76.7-50.2-111.8-31.7-163.7 20.7-58 82.4-205.5 69.9-353.7-5.6-66.5-26.1-133.2-71.9-192-7.6-9.8-15-19.2-22.2-28.2C1017.6 252.8 957.2 215 902.2 215c-5.8 0-12.8.8-20.5 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1039 1701s-1.1-65.8-18.3-228.5c-6.2-58.7-14.5-130.1-25.7-215.5-.9-7-1.8-14-2.5-20.8-8.8-79.7-7.5-148.2-.7-208.8 8.2-74.1 24.5-136.3 39.8-192.6 20.6-75.4 39.5-140 35.5-207.8-.6-9.7-1.4-19.7-2.5-29.8-7.2-67-25.3-141.2-48.3-206.3-33.5-94.6-77.5-170-113.9-175.9-7.7-1.3-14.6-.4-20.6 2.4-34.4 15.8-41.4 93.3-33.5 184 6.4 73.3 22.4 155.2 41.5 220.1 3 10.3 6.1 20.2 9.3 29.5 21.5 63.6 23.2 123.8 13.8 187.4-7.9 53.8-23.8 109.9-42.2 172.6-12.5 42.6-26.3 88.1-39.6 138-6.2 23.1-9.2 47.6-9.9 73.2-2.1 78.5 19 165.8 46 243.9C911.2 1593.8 971 1697 971 1697"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683 1339s64.1 92.9 184.1 127.1c43.9 12.5 95.2 17.1 153.6 6.4 68.3-12.5 146.3-45.8 233.4-112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M677 1149c2.9 1.9 56.3 47.5 144.1 73.2 47.8 14 105.8 22.1 171.4 14 63.8-7.9 134.8-31.1 210.5-79.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M741 967s51 26 129.6 44c35.5 8.1 76.6 14.6 121.2 16.3 54 2.1 113-2.8 173.2-20.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M751 859s71.1-13.7 161.8-20.6c37.5-2.8 78.2-4.5 118.8-3.6 66.8 1.5 132.7 10.1 181.5 32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M711 737s63-75.2 178.7-115.5c49-17.1 107.6-28 174.8-24.2 54 3 113.7 15.5 178.5 41.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666 539s44.2-100.5 182.1-137.7c45.3-12.2 100.7-17.6 168-10.4 40.2 4.3 84.7 13.1 133.8 27.7.4.1.7.2 1.1.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeanut02);
export default __webpack_public_path__ + "static/media/peanut-02.0f48686f705d399ba1b59280cabb857d.svg";
export { ForwardRef as ReactComponent };